// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"cut"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M8.12134 15.8787L20 4M8.12134 15.8787C9.29291 17.0503 9.29289 18.9497 8.12132 20.1213C6.94975 21.2929 5.05025 21.2929 3.87868 20.1213C2.70711 18.9497 2.70711 17.0503 3.87868 15.8787C5.05025 14.7071 6.94976 14.7071 8.12134 15.8787ZM15 15L20 20M8.12132 8.12132C6.94975 9.29289 5.05025 9.29289 3.87868 8.12132C2.70711 6.94975 2.70711 5.05025 3.87868 3.87868C5.05025 2.70711 6.94975 2.70711 8.12132 3.87868C9.29289 5.05025 9.29289 6.94975 8.12132 8.12132ZM8.12132 8.12132L12 11.9998","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-cut')
export default class CutIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'cut',
    }
  }
}
